import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { payroll } = entities;
const { POST, PATCH } = methods;

const query = getQueryMethod(meloAPI, payroll);

const endpoints = {
  createCollaborator: async (businessId, collaboratorData) => {
    return await query('collaborators', POST, { businessId, ...collaboratorData });
  },
  createCollaboratorsByFile: async (businessId, filePath) => {
    return await query('collaborators/batch', POST, { businessId, filePath });
  },
  getCollaborator: async (businessId, collaboratorId) => {
    return await query(`collaborators/${businessId}/${collaboratorId}`);
  },
  updateCollaborator: async (businessId, collaboratorId, collaboratorData) => {
    return await query(`collaborators/${businessId}/${collaboratorId}`, PATCH, collaboratorData);
  },
  deleteCollaborator: async (businessId, collaboratorId) => {
    return await query(`collaborators/${businessId}/${collaboratorId}/delete`, PATCH);
  },
  getCollaborators: async businessId => {
    return await query(`collaborators/${businessId}`);
  },
  getCollaboratorsById: async (businessId, collaboratorsIds) => {
    const queryParams = getURLParams(collaboratorsIds);
    return await query(`collaborators/${businessId}/by/ids?${queryParams}`);
  },
  getCollaboratorsPaginated: async ({ businessId, paymentStatus }) => {
    const queryParams = getURLParams({ paymentStatus });

    return await query(`collaborators/${businessId}?${queryParams}`);
  },
  getCollaboratorPayoutPaginated: async ({ collaboratorId, paymentStatus }) => {
    const queryParams = getURLParams({ paymentStatus });
    return await query(`collaborators/${collaboratorId}/payouts/paginated?${queryParams}`);
  },
  getCollaboratorsBatchCreationById: async collaboratorsbatchId => {
    return await query(`collaborators/batch/creation/by/${collaboratorsbatchId}`);
  },

  payCollaborators: async body => {
    return await query('pay', POST, body);
  },
  getPayrollPayoutVoucher: async (businessId, payoutId) => {
    return await query(`voucher/payout/${businessId}/${payoutId}`);
  },
  getCollaboratorPayoutVoucher: async (businessId, payoutId, collaboratorId) => {
    return await query(`voucher/collaborator/${businessId}/${payoutId}/${collaboratorId}`);
  },
  deleteCollaboratorDruoBanksAccounts: async (businessId, collaboratorId, druoAccountsIds) => {
    return await query(`collaborators/${businessId}/${collaboratorId}/delete/bank-account`, PATCH, { druoAccountsIds });
  }
};

export default endpoints;
